import { render, staticRenderFns } from "./actionbutton.vue?vue&type=template&id=58038794"
import script from "./actionbutton.vue?vue&type=script&lang=js"
export * from "./actionbutton.vue?vue&type=script&lang=js"
import style0 from "./actionbutton.vue?vue&type=style&index=0&id=58038794&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports